import { Column } from "react-table";

import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import { ITableProps } from "src/library/components/Tables/Table";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import { IProcessJobError } from "src/core/process-job/api/processJobs.api";

export type IOrderImportErrorsColumns = Partial<ITableProps>;

export interface IOrderImportErrorTable {
  terminology: ITerminology;
}

export const orderImportErrorsTableColumns = (params: IOrderImportErrorTable): Array<Column<IProcessJobError<"import-file-order">>> => [
  globalTableColumns.id(),

  globalTableColumns.standardText({
    Header: "Message",
    accessor: "message",
    multiLine: true,
    width: 300
  }),
  globalTableColumns.standardText({
    Header: "Drop",
    accessor: "data.BranchCode",
    width: 100,
    sortable: false,
    filterable: false
  }),
  globalTableColumns.standardText({
    Header: "DeliveryDate",
    accessor: "data.DeliveryDate",
    width: 100,
    sortable: false,
    filterable: false
  }),
  globalTableColumns.standardText({
    Header: params.terminology?.partNumber.singular.text || "Part number",
    accessor: "data.PartNumber",
    width: 150,
    sortable: false,
    filterable: false
  }),
  globalTableColumns.standardText({
    Header: "Quantity",
    accessor: "data.Quantity",
    width: 100,
    sortable: false,
    filterable: false
  }),
  globalTableColumns.standardText({
    Header: "Line Number",
    accessor: "data.LineNumber",
    width: 100,
    sortable: false,
    filterable: false
  })
];
